"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConferenceMainView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _mainGridView = require("./mainGridView");
var _SidePane = _interopRequireDefault(require("./SidePane"));
var _FullPageProgress = _interopRequireDefault(require("../components/FullPageProgress"));
var _screenShareView = _interopRequireDefault(require("./screenShareView"));
var _useUISettings2 = require("../components/AppData/useUISettings");
var _hooks = require("../common/hooks");
var _whiteboard = require("../plugins/whiteboard");
var _useAppConfig = require("../components/AppData/useAppConfig");
var _constants = require("../common/constants");
var _useRefreshSessionMetadata = require("../components/hooks/useRefreshSessionMetadata");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WhiteboardView = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./WhiteboardView"));
  });
});
var HLSView = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./HLSView"));
  });
});
var ActiveSpeakerView = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./ActiveSpeakerView"));
  });
});
var ConferenceMainView = function ConferenceMainView() {
  var localPeerRole = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerRoleName);
  var peerSharing = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerScreenSharing);
  var peerSharingAudio = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingAudio);
  var peerSharingPlaylist = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingVideoPlaylist);
  var _useWhiteboardMetadat = (0, _whiteboard.useWhiteboardMetadata)(),
    whiteboardShared = _useWhiteboardMetadat.whiteboardOwner;
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  (0, _hooks.useBeamAutoLeave)();
  (0, _useRefreshSessionMetadata.useRefreshSessionMetadata)();
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var isHeadless = (0, _useUISettings2.useIsHeadless)();
  var headlessUIMode = (0, _useAppConfig.useAppConfig)("headlessConfig", "uiMode");
  var _useUISettings = (0, _useUISettings2.useUISettings)(),
    uiViewMode = _useUISettings.uiViewMode,
    isAudioOnly = _useUISettings.isAudioOnly;
  var hlsViewerRole = (0, _useUISettings2.useHLSViewerRole)();
  (0, _react.useEffect)(function () {
    if (!isConnected) {
      return;
    }
    var audioPlaylist = JSON.parse(process.env.REACT_APP_AUDIO_PLAYLIST || "[]");
    var videoPlaylist = JSON.parse(process.env.REACT_APP_VIDEO_PLAYLIST || "[]");
    if (videoPlaylist.length > 0) {
      hmsActions.videoPlaylist.setList(videoPlaylist);
    }
    if (audioPlaylist.length > 0) {
      hmsActions.audioPlaylist.setList(audioPlaylist);
    }
  }, [isConnected, hmsActions]);
  if (!localPeerRole) {
    // we don't know the role yet to decide how to render UI
    return null;
  }
  var ViewComponent;
  if (localPeerRole === hlsViewerRole) {
    ViewComponent = HLSView;
  } else if (whiteboardShared) {
    ViewComponent = WhiteboardView;
  } else if ((peerSharing && peerSharing.id !== (peerSharingAudio === null || peerSharingAudio === void 0 ? void 0 : peerSharingAudio.id) || peerSharingPlaylist) && !isAudioOnly) {
    ViewComponent = _screenShareView["default"];
  } else if (uiViewMode === _constants.UI_MODE_ACTIVE_SPEAKER || isHeadless && headlessUIMode === _constants.UI_MODE_ACTIVE_SPEAKER) {
    ViewComponent = ActiveSpeakerView;
  } else {
    ViewComponent = _mainGridView.MainGridView;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageProgress["default"], {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        size: "100%",
        position: "relative"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ViewComponent, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePane["default"], {})]
    })
  });
};
exports.ConferenceMainView = ConferenceMainView;